function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21455"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M16 16H0V0h16z",
    style: {
      opacity: 0.87,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17703",
    d: "M3.733 7.467 0 3.733 3.733 0",
    transform: "rotate(-90 7 2.667)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgChevronDown;